import { useCallback } from 'react'
import { ampli } from '../ampli'

const AMPLITUDE_ENV =
	window.REACT_APP_AMPLITUDE_ENV || process.env.REACT_APP_AMPLITUDE_ENV
const AMPLITUDE_API_KEY =
	window.REACT_APP_AMPLITUDE_API_KEY ||
	process.env.REACT_APP_AMPLITUDE_API_KEY

export const initAmplitude = () => {
	ampli.load({
		environment: AMPLITUDE_ENV,
		client: {
			apiKey: AMPLITUDE_API_KEY,
			configuration: {
				defaultTracking: false,
			},
		},
	})
}

const eventMapping = {
	openTask: (payload) => ampli.abrirTarefa(payload),
	postponeTask: (payload) => ampli.adiarTarefa(payload),
	approveTask: (payload) => ampli.aprovarTarefa(payload),
	cancelTask: (payload) => ampli.cancelarTarefa(payload),
	sendToManager: (payload) => ampli.enviarGestor(payload),
	sendToMedic: (payload) => ampli.enviarMedico(payload),
	closeTask: (payload) => ampli.fecharTarefa(payload),
	refuseTask: (payload) => ampli.recusarTarefa(payload),
	forwardTask: (payload) => ampli.reencaminharTarefa(payload),
	resolveTask: (payload) => ampli.resolverTarefa(payload),
	submitTask: (payload) => ampli.submeterTarefa(payload),
	finishTask: (payload) => ampli.terminarTarefa(payload),
	nullifyTask: (payload) => ampli.anularTarefa(payload),
}

export const useAnalytics = () => {
	const ampliIdentify = (userId, properties) => {
		try {
			ampli.identify(userId, properties)
		} catch (e) {
			console.error('Amplitude error: ', e)
		}
	}

	const ampliFlush = () => {
		try {
			ampli.flush()
		} catch (e) {
			console.error('Amplitude error: ', e)
		}
	}

	const dispatchAnalyticsEvent = useCallback((action, payload) => {
		if (!ampli.isLoaded) {
			initAmplitude()
		}

		try {
			eventMapping[action]?.(payload)
		} catch (e) {
			console.error('Amplitude error: ', e)
		}
	}, [])

	return { initAmplitude, ampliIdentify, dispatchAnalyticsEvent, ampliFlush }
}
